import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
    soundEnabled: boolean;
    notificationsEnabled: boolean;
    toggleSound: () => void;
    toggleNotifications: () => void;
    setSound: (enabled: boolean) => void;
    setNotifications: (enabled: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
    persist(
        (set) => ({
            soundEnabled: true,
            notificationsEnabled: true,
            toggleSound: () => set((state) => ({ soundEnabled: !state.soundEnabled })),
            toggleNotifications: () => set((state) => ({ notificationsEnabled: !state.notificationsEnabled })),
            setSound: (enabled) => set({ soundEnabled: enabled }),
            setNotifications: (enabled) => set({ notificationsEnabled: enabled }),
        }),
        {
            name: 'admin-settings',
        }
    )
);
